import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  FormHelperText,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@material-ui/core";
import { useFormik } from "formik";
import { X } from "phosphor-react";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { fpatch, fpost } from "../../../../../API/callsAPI";
import SelectUserModal from "../../../../Utilities/ManageUsers/SelectUsersModal/SelectUserModal.component";
import UserViewerForManageUsers from "../../../../Utilities/ManageUsers/UsersViewerForManageUsers/UserViewerForManageUsers.component";
import useStyles from "./NewOrEditTaskPhaseModal.style";

const NewOrEditTaskPhaseModal = ({
  type,
  handleClose,
  selectedPhase,
  templateId,
  updateRefreshCounter,
  departments,
  setSnackValue,
  usersList,
  taskStatusList,
}) => {
  const classes = useStyles();
  const [isUpdating, setIsUpdating] = useState(false);
  const [projectUsers, setProjectUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);

  const NewPhaseValidationScheme = yup.object({
    phaseName: yup
      .string("String required")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required("This is a required field"),
    duration: yup.number("number required").required("this field is required"),
    hours: yup.number("number required").required("this field is required"),
    department: yup
      .string("string required")
      .required("this field is required"),
  });
  
  const formik = useFormik({
    initialValues: {
      phaseName: selectedPhase?.name ? selectedPhase?.name : "",
      duration: selectedPhase?.number_of_days
        ? selectedPhase?.number_of_days
        : "",
      hours: selectedPhase?.number_of_hours
        ? selectedPhase?.number_of_hours
        : 0,
      department: selectedPhase?.dept,
      description: selectedPhase?.description ? selectedPhase?.description : "",
      status: selectedPhase?.status ? selectedPhase?.status : null,
    },
    validationSchema: NewPhaseValidationScheme,
    onSubmit: async (values) => {
      const assignedUsers = selectedUsers.map((user) => user?.value);

      const phaseData = {
        name: values.phaseName,
        number_of_days: values.duration,
        number_of_hours: values.hours,
        dept: values.department.id,
        description: values.description,
        template: templateId,
        users_to_assign: assignedUsers,
        color: "decolor",
        status: values.status,
      };

      try {
        setIsUpdating(true);
        if (type === "New") {
          const newData = { url: `phase/`, data: phaseData };
          const newRes = await fpost(newData);
          setSnackValue({
            isOpen: true,
            message: `successfully created task phase "${newRes?.data?.name}"`,
            isError: false,
          });
          updateRefreshCounter();
          handleClose();
          setIsUpdating(false);
        } else {
          const editData = {
            url: `phase/${selectedPhase?.id}/`,
            data: phaseData,
          };
          const editRes = await fpatch(editData);
          setSnackValue({
            isOpen: true,
            message: `successfully edited task phase "${editRes?.data?.name}"`,
            isError: false,
          });
          updateRefreshCounter();
          handleClose();
          setIsUpdating(false);
        }
      } catch (error) {
        setSnackValue({
          isOpen: true,
          message: `${error}`,
          isError: true,
        });
        setIsUpdating(false);
      }
    },
  });

  const handleSelectUser = (users) => {
    setSelectedUsers(users);
  };

  const handleSelectUserModalState = () => {
    setSelectUserModalOpen(!isSelectUserModalOpen);
  };

  useEffect(() => {
    setSelectedUsers([]);
    if (formik.values?.department) {
      const users = usersList?.filter((el) =>
        formik.values?.department?.users?.find((user) => user.id === el.value)
      );
      setProjectUsers(users);
    }
  }, [formik.values?.department, usersList]);

  useEffect(() => {
    if (selectedPhase?.users_to_assign?.length > 0) {
      setSelectedUsers(
        selectedPhase?.users_to_assign?.map((el) => {
          const data = {
            label: el.first_name + " " + el.last_name,
            value: el.id,
            avatar: el?.avatar,
          };
          return data;
        })
      );
    }
  }, [selectedPhase, usersList]);
  console.log(formik.values.department);
  
  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <form onSubmit={formik.handleSubmit}>
            <div className={classes.cardTitle}>
              <span className={classes.title}>{type} Task Phase</span>
              <Button
                className={classes.closeButton}
                onClick={() => handleClose()}
              >
                <X size="30px" />
              </Button>
            </div>
            <br />

            <div>
              <span className={classes.inputTitle}>
                Task Phase Name <span style={{ color: "red" }}>*</span>
              </span>
              <div className={classes.cardContentDiv1}>
                <TextField
                  placeholder="Enter a task phase name"
                  fullWidth
                  type="text"
                  className={classes.cardContentInput}
                  InputProps={{ disableUnderline: true }}
                  name="phaseName"
                  id="phaseName"
                  value={formik.values.phaseName}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.phaseName)}
                />
                <FormHelperText style={{ color: "rgb(255,204,0)" }}>
                  {formik.errors.phaseName ? "Phase Name is required" : null}
                </FormHelperText>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div>
                <span className={classes.inputTitle}>
                  Duration (Days) <span style={{ color: "red" }}>*</span>
                </span>
                <div className={classes.cardContentDiv1}>
                  <TextField
                    placeholder="Enter duration (in days)"
                    fullWidth
                    type="number"
                    className={classes.cardContentInput}
                    InputProps={{ disableUnderline: true }}
                    name="duration"
                    id="duration"
                    value={formik.values.duration}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.duration)}
                  />
                  <FormHelperText style={{ color: "rgb(255,204,0)" }}>
                    {formik.errors.duration ? "Duration is required" : null}
                  </FormHelperText>
                </div>
              </div>
              <div>
                <span className={classes.inputTitle}>
                  Duration (Hours) <span style={{ color: "red" }}>*</span>
                </span>
                <div className={classes.cardContentDiv1}>
                  <TextField
                    placeholder="Enter duration (in hours)"
                    fullWidth
                    type="number"
                    className={classes.cardContentInput}
                    InputProps={{ disableUnderline: true }}
                    name="hours"
                    id="hours"
                    value={formik.values.hours}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.hours)}
                  />
                  <FormHelperText style={{ color: "rgb(255,204,0)" }}>
                    {formik.errors.hours ? "Hours is required" : null}
                  </FormHelperText>
                </div>
              </div>
            </div>
            <div>
              <span className={classes.inputTitle}>Select Department</span>
              <span style={{ color: "red" }}>*</span>
              <div className={classes.cardContentDiv1}>
                <Select
                  // required
                  style={{ width: "100%" }}
                  labelId="demo-simple-select-outlined-label"
                  id="department"
                  disableUnderline
                  className={classes.cardContentInput1}
                  label="Select Task Template"
                  onChange={formik.handleChange}
                  name="department"
                  value={formik.values.department}
                  error={Boolean(formik.errors.department)}
                >
                  <MenuItem value="">None</MenuItem>
                  {departments &&
                    departments.map((eachDepartment) => (
                      <MenuItem value={eachDepartment}>
                        {eachDepartment.name} - {eachDepartment.id}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText style={{ color: "rgb(255,204,0)" }}>
                  {formik.errors.department ? "Department is required" : null}
                </FormHelperText>
              </div>
            </div>
            <div
              className={classes.textFieldContainer}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <div>
                <span>Select Status</span>
                <div
                  className={classes.cardContentDiv2}
                  style={{ width: "150px", marginTop: "5px", height: "40px" }}
                >
                  <Select
                    style={{ width: "100%" }}
                    labelId="demo-simple-select-outlined-label"
                    id="selectStatus"
                    label="Select Status"
                    disableUnderline
                    className={classes.cardContentInput1}
                    onChange={formik.handleChange}
                    name="status"
                    value={formik.values.status}
                    defaultValue={null}
                  >
                    <MenuItem value={null}>None</MenuItem>
                    {taskStatusList &&
                      taskStatusList.map((eachStatus) => (
                        <MenuItem value={eachStatus.id}>
                          <span
                            style={{
                              height: "15px",
                              width: "15px",
                              backgroundColor: `rgb(${eachStatus?.color})`,
                              borderRadius: "50%",
                              display: "inline-block",
                              margin: "0px 5px",
                            }}
                          ></span>
                          {eachStatus.name} - {eachStatus.code}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              </div>
              <div style={{ maxWidth: "50%" }}>
                <span>Status Code</span>
                <div
                  style={{ marginTop: "5px" }}
                  className={classes.cardContentDiv3}
                >
                  <TextField
                    className={classes.cardContentInput1}
                    InputProps={{
                      disableUnderline: true,
                      style: { opacity: "0.4" },
                    }}
                    disabled
                    fullWidth
                    value={
                      taskStatusList?.find(
                        (eachStatus) => eachStatus.id === formik.values.status
                      )?.code
                    }
                  />
                </div>
              </div>
            </div>
            <div className={classes.inputTitle}>
              <label>Select Users</label>
            </div>
            {formik.values.department ? (
              <UserViewerForManageUsers
                currentUsers={selectedUsers}
                handleSelectUserModalChange={handleSelectUserModalState}
                handleSelectUsers={handleSelectUser}
              />
            ) : (
              <div
                style={{ padding: "4px 0px", textAlign: "end" }}
                className={classes.inputTitle}
              >
                Please Select a department first
              </div>
            )}
            <div>
              <span className={classes.inputTitle}>Description</span>
              <div className={classes.cardContentDiv2}>
                <TextField
                  type="text"
                  fullWidth
                  multiline={true}
                  InputProps={{ disableUnderline: true }}
                  placeholder="Enter a Description..."
                  name="description"
                  className={classes.cardContentInput}
                  value={formik.values.description}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
            <CardActions className={classes.buttons}>
              <Button
                size="small"
                className={classes.confirmButton}
                disableElevation
                type="submit"
                value="Submit"
                disabled={isUpdating ? true : false}
              >
                {isUpdating ? (
                  <CircularProgress style={{ width: "20px", height: "20px" }} />
                ) : (
                  <span>Confirm</span>
                )}
              </Button>
              <Button
                size="small"
                className={classes.cancelButton}
                disableElevation
                onClick={() => {
                  handleClose();
                }}
                disabled={isUpdating ? true : false}
              >
                {isUpdating ? (
                  <CircularProgress style={{ width: "20px", height: "20px" }} />
                ) : (
                  <span>Cancel</span>
                )}
              </Button>
            </CardActions>
          </form>
        </CardContent>
      </Card>
      <Modal
        className={classes.modal}
        open={isSelectUserModalOpen}
        onClose={() => setSelectUserModalOpen(!isSelectUserModalOpen)}
      >
        <SelectUserModal
          closeModal={() => setSelectUserModalOpen(!isSelectUserModalOpen)}
          assignedUser={selectedUsers}
          usersList={projectUsers}
          handleSelectUsers={handleSelectUser}
        />
      </Modal>
    </div>
  );
};

export default NewOrEditTaskPhaseModal;
